import { Component, EventEmitter, Input, Output, TrackByFunction } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Tariff } from '../tariff.model';
import { UtilsService } from '../../../core/services/utils.service';

@UntilDestroy()
@Component({
  selector: 'tax-vertical-tariff-list',
  templateUrl: 'vertical-tariff-list.component.html',
  styleUrls: ['vertical-tariff-list.component.sass'],
})
export class VerticalTariffListComponent {
  @Input() activeTariff?: Tariff;
  @Input() selectedTariff?: Tariff;
  @Input() tariffs: Tariff[] = [];

  @Output() emitSelectedTariff: EventEmitter<Tariff> = new EventEmitter<Tariff>();

  readonly trackById: TrackByFunction<Tariff> = this.utilsService.trackById;

  constructor(
    private utilsService: UtilsService,
  ) {
  }

  selectTariff(selectedTariff: Tariff): void {
    this.emitSelectedTariff.emit(selectedTariff);
  }
}
